import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetRecipeNotificationsByOrderInput } from './GetRecipeNotificationsByOrderInput';
import { GetRecipeNotificationsByOrderOutput } from './GetRecipeNotificationsByOrderOutput';

export class GetRecipeNotificationsByOrderService extends HttpServiceBase {

  handle = (input: GetRecipeNotificationsByOrderInput): Promise<Result<GetRecipeNotificationsByOrderOutput> | null> => {
    const promise = this.http.get<Result<GetRecipeNotificationsByOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/recipe-notifications`);
    return promise;
  }
}